module.exports = __webpack_public_path__ + "img/category-fishing-game-hover.0d11d18f.png";